// 单位mm
export const BUILD_PROPERTIES = {
  MAX_INPUT: 10000,
  MIN_INPUT: 10,
  ROTATION_ANGLE_RANGE: [0, 360],
  WALL: {
    DEFAULT_THICKNESS: 100,
    THICKNESS_OPTIONS: [
      { label: '65mm', value: 65 },
      { label: '70mm', value: 70 },
      { label: '90mm', value: 90 },
      { label: '100mm', value: 100 },
      { label: '120mm', value: 120 },
      { label: '130mm', value: 130 },
      { label: '135mm', value: 135 },
      { label: '150mm', value: 150 },
      { label: '180mm', value: 180 },
      { label: '200mm', value: 200 }
    ]
  },
  SQUARE_COLUMN: {
    DEFAULT_LENGTH: 500,
    DEFAULT_WIDE: 500,
    DEFAULT_ROTATION_ANGLE: 0
  },
  CYLINDER_COLUMN: {
    DEFAULT_DIAMETER: 500
  }
} as const;
